import { Suspense } from 'react';

import { LoadRemote } from '@mindtickle/ui-shell-core/DynamicRemote';
import { DYNAMIC_REMOTES } from '~/config/app.constants';
import PollingHandlers from '../PollingHandlers';

const RemoteModals = ({ email }: { email: string }) => (
  <>
    <Suspense fallback={<span />}>
      <LoadRemote remote={DYNAMIC_REMOTES.CHOOSE_LEARNING_SITE} loader={<span />} />
    </Suspense>
    <Suspense fallback={<span />}>
      <LoadRemote remote={DYNAMIC_REMOTES.ANNOUNCEMENT} loader={<span />}>
        {remoteModule => <PollingHandlers remoteModule={remoteModule} />}
      </LoadRemote>
    </Suspense>
    <Suspense fallback={<span />}>
      <LoadRemote remote={DYNAMIC_REMOTES.GET_SUPPORT} loader={<span />} email={email} />
    </Suspense>
  </>
);

export default RemoteModals;
